module.exports = __webpack_public_path__ + "static/media/dk.fab04e8b.svg";